<template>
  <div class="subscribe">
    <div class="hero is-primary">
      <div class="hero-body">
        <div class="container">
          <h1 class="title is-size-1">Subscribe</h1>        
        </div>
      </div>
    </div>
    <div class="container">

      <br/>
      <br/>

      <div v-if="!isSubscribed">
        <div class="has-text-centered">
          <div v-if="!subscriptionChecked">
              <P class="blink is-size-4">Please wait, checking for subscription...</p>
          </div>
          <div v-if="subscriptionChecked">
            <br/>
              <P class="is-italic is-size-4">No subscrpition found.</p>
              <br/><br/>
              <p class="is-size-5">You can subscribe below for $2.50 CAD per month (billed automatically).<br/>You can come back and unsubscribe on this page at any time.</p>
            <br/>
          </div>
        </div>
      </div>
      <div v-if="isSubscribed" class="has-text-centered">
        <div>
            <P class="is-italic is-size-4">Valid subscrpition found.  Thanks for your membership.</p>
        </div>
        <br/>
        <br/>

        <p style="display: none;">
          <a href="https://www.paypal.com/cgi-bin/webscr?cmd=_subscr-find&alias=ZJAACCYPP7Q36" target="_blank">
            <img src="https://www.paypalobjects.com/en_US/i/btn/btn_unsubscribe_LG.gif" BORDER="0">
          </a>
        </p>

        <div v-if="subscriptionId != 'FREE'">
          <div class="unsubscribe-box">
            <h3 class="is-size-5">Unsubscribe:</h3>
            <br/>
            <p>
            <span style="color: white;">
              Reason for unsubscribing? <br/><br/>
              <input type="text" size="30" id="unsubscribeReason" v-model="unsubscribeReason"/>
            </span>
            </p>
            <br/>
            <br/>
            <p>
              <a v-on:click="unsubscribe">
                <img src="https://www.paypalobjects.com/en_US/i/btn/btn_unsubscribe_LG.gif"/>
              </a>
            </p>
          </div>
        </div>

        <br/>
        <br/>
        <br/>
        <p>You can also manage your PayPal Subscriptions 
          <a href="https://www.paypal.com/cgi-bin/webscr?cmd=_subscr-find&alias=ZJAACCYPP7Q36" target="_blank">here</a>.
        </p>
        <br/>
      </div>

      <div v-show="!isSubscribed">
        <br/>
        <br/>
        <div class="subscribe-box">
          <br/>
          <br/>
          <div id="paypal-button-container-P-23S87341G5692374SMCO3GBI"></div>
          <br/>
          <br/>
        </div>
      </div>
      <br/>
      <br/>
      <br/>
      <br/>
      <!--
      <button class="button is-success" @click="unsubscribeUser();">unsubscribe test</button>
      -->
      <!--
      <button class="button is-success" @click="subscribeUser( {subscriptionId : '1'},'');"/>
      -->
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: 'subscribe',
  data () {
    return {
      debugMode: (process.env.VUE_APP_DEBUG_MODE === "true" ? true : false),
      isSubscribed: false,
      subscriptionChecked: false,
      subscriptionId: '',
      accessToken: '',
      unsubscribeReason: ''
    }
  },
  methods: {
    unsubscribe: function() {
      if (confirm("Are you sure you want to unsubscribe?")) {

        //var url = "https://api-m.sandbox.paypal.com/v1/billing/subscriptions/" + this.subscriptionId + "/cancel";
        var url = "https://api-m.paypal.com/v1/billing/subscriptions/" + this.subscriptionId + "/cancel";

        axios.post(url, {
          "reason": this.unsubscribeReason
        }, 
        {
          headers: {
            'Authorization': `Bearer ${this.accessToken}`,
            'Content-Type': 'application/json'
          }
        })
        .then((response) => {
            //console.log(response);

            this.unsubscribeReason = "";
            this.unsubscribeUser();

        }, (error) => {
          alert("Error unsubscribing via PayPal.");
          //console.log(error);
        });

      }
    },
    getToken: function() {
      //paypal token
      var url = (this.debugMode ? "http://localhost:8080/token" : "https://axes2api.azurewebsites.net/token")

      var token = this.$parent.getApiToken();
      
      axios.get(url,{
            headers: {
                authorization: token
            }
        })
        .then((response) => {
          if (response.data.error != null) {
              //console.log("error retrieving token");
          } else if (response.data.length == 0) {
              //console.log("no token found");
          } else {
            //console.log("got access token");
            this.accessToken = response.data.access_token;
            //console.log(this.accessToken);
          }
        }, (error) => {
          console.log("error getting token: \n\n" + error.toString())
        });
    },
    checkSubscription: function() {

      if (this.$auth.isSubscribed) {
        this.isSubscribed = true;
        this.subscriptionChecked = true;
        return true;
      }

      var url = (this.debugMode ? "http://localhost:8080/subscription?email=" : "https://axes2api.azurewebsites.net/subscription?email=")

      var token = this.$parent.getApiToken();

      axios.get(url + this.$auth.user.email,{
          headers: {
            authorization: token
          }
        })
        .then((response) => {
          if (response.data.error != null) {
              alert("Error checking for subscription.\n\n" + response.data.error.toString())
              this.subscriptionChecked = true;
          } else if (response.data.length == 0) {
              //no subscription found
              this.subscriptionChecked = true;
          } else {
              //subscription found

              this.$auth.isSubscribed = true;

              this.isSubscribed = true;
              this.subscriptionChecked = true;
              this.subscriptionId = response.data[0].subscriptionId;
          }
        }, (error) => {
          alert("Error checking for subscription.\n\n" + error.toString())
          this.subscriptionChecked = true;
      });
    },
    unsubscribeUser: function() {
      //var subscriptionId = "I-BBBBBBBBBBBB";

      var url = (this.debugMode ? "http://localhost:8080/unsubscribe" : "https://axes2api.azurewebsites.net/unsubscribe")

      var subscriptionId = this.subscriptionId;
      
      //console.log("unsubscribe " + subscriptionId + " via " + url + " for " + this.$auth.user.email);

      var token = this.$parent.getApiToken();

      axios.post(url, {
          subscriptionId: subscriptionId
        },
        {
          headers: {
            authorization: token
          }
      })
      .then((response) => {

        alert("You are unsubscribed.");
        //console.log(response);
        
        this.isSubscribed = false;
        this.subscriptionId = '';
        this.subscriptionChecked = false;

        this.checkSubscription();

      }, (error) => {
        alert("Error unsubscribing from Axes2.");
        //console.log(error);
      });
    },
    subscribeUser: function(data, actions) {
      //console.log("subscribeUser");
      //console.log(data);
      //console.log(actions);

      var subscriptionId = data.subscriptionID;

      var token = this.$parent.getApiToken();

      var url = (this.debugMode ? "http://localhost:8080/subscribe" : "https://axes2api.azurewebsites.net/subscribe")

      axios.post(url, {
          email: this.$auth.user.email,
          subscriptionId: subscriptionId,
          dateTimeStamp: new Date().toISOString()
        },
        {
          headers: {
            authorization: token
          }
      })
      .then((response) => {
        alert("Thanks for subscribing!");
        this.checkSubscription();
        //console.log(response);
      }, (error) => {
        alert("Error subscribing to Axes2");
        //console.log(error);
      });
      /*
      var id = actions.order.id;
      var status = actions.order.status;

      var payer_firstname = actions.order.payer.name.given_name;
      var payer_lastname = actoins.order.payer.name.surname;
      var payer_email = actions.order.payer.email_address;
      var payer_id = actions.order.payer.payer_id;
      */
    }
  },
  components: {
  },
  mounted(){

    this.getToken();

    paypal.Buttons({
        style: {
            shape: 'pill',
            color: 'black',
            layout: 'vertical',
            label: 'subscribe'
        },
        createSubscription: function(data, actions) {
          return actions.subscription.create({
            // Creates the subscription
            plan_id: 'P-23S87341G5692374SMCO3GBI'
          });
        },
        onApprove: function(data, actions) {
          //alert(data.subscriptionID);
          //console.log("onApprove data.subscrpitionIO: " + data.subscriptionID);
          //
          subscribeUser(data,actions);
          //
        }
    }).render('#paypal-button-container-P-23S87341G5692374SMCO3GBI'); // Renders the PayPal button

    if (!this.isSubscribed && !this.subscriptionChecked) {
        this.checkSubscription();
    } else {
        //alert("subscription alredy checked");
    }

  },
  created(){
    window.subscribeUser = this.subscribeUser;
  }
}
</script>



<style lang="scss" scoped>
  .subscribe-box, .unsubscribe-box {
    padding: 10px;
    width: 350px;
    border: solid gray 1px;
    border-radius: 5px;
    margin: auto;
  }
  .blink {
      color: yellow;
      animation: blink-animation 1s steps(5, start) infinite;
      -webkit-animation: blink-animation 1s steps(5, start) infinite;
  }
  @keyframes blink-animation {
      to {
      visibility: hidden;
      }
  }
  @-webkit-keyframes blink-animation {
      to {
      visibility: hidden;
      }
  }

  .subscribe {
    font-family: verdana;
    color: white;
  }

  .hero {
    font-family: '28 Days Later';
    background-color: black;
  }
</style>